import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { makeStyles } from '@material-ui/core/styles';
import Swipeable from 'react-swipeable';
import Table from '@material-ui/core/Table';
import clsx from 'clsx';
import EnhancedTableHead from 'components/molecules/MbTable/EnhancedTableHead';
import EnhancedTableBody from 'components/molecules/MbTable/EnhancedTableBody';

function desc(a, b, order) {
  let aData = a[order];
  let bData = b[order];

  if (!isNaN(aData) && !isNaN(bData)) {
    // 둘다 숫자면
    aData = Number(aData);
    bData = Number(bData);
  }
  if (bData < aData) {
    return -1;
  }
  if (bData > aData) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const sort = cmp(a[0], b[0]);
    if (sort !== 0) return sort;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(sort, order) {
  return sort === 'desc'
    ? (a, b) => desc(a, b, order)
    : (a, b) => -desc(a, b, order);
}

const useStyles = makeStyles((theme) => ({
  tableCustomScrollBar: {
    height: 'calc(100% - 38px) !important',
    '& > div:first-child': {
      position: 'relative !important',
      height: '350px',
    },
    '& > div:last-child': {
      zIndex: 22,
    },
    '&.virtualAccount': {
      height: 130,
      '& > div:first-child': {
        height: 'auto',
      },
    },
  },
  tableWrapper: {
    display: 'flex',
    flex: '1 0 auto',
    '& > div': {
      width: '100%',
      flex: '1 0 auto',
    },
  },
  tableTitle: {
    marginTop: 0,
    marginBottom: 5,
    fontWeight: 'normal',
    fontSize: '16px',
    color: theme.palette.common.black,
  },
}));

export default function BasicTable({
  className,
  sort: propSort,
  order: propOrder,
  headCells,
  list = [],
  tableKey = null,
  error,
  loading,
  customized,
  virtualAccount,
  tableTitle,
}) {
  let scrollRef = React.createRef();
  const classes = useStyles();
  const [sort, setSort] = React.useState(propSort);
  const [order, setOrder] = React.useState(propOrder);
  const handleRequestSort = (event, property) => {
    const isDesc = order === property && sort === 'desc';
    setSort(isDesc ? 'asc' : 'desc');
    setOrder(property);
  };

  const handleTableSwiping = (e, deltaX, deltaY, absX, absY, velocity) => {
    let sX = scrollRef.current.getScrollLeft() + deltaX;
    scrollRef.current.scrollLeft(sX);
  };

  return (
    <>
      {typeof tableTitle !== 'undefined' && (
        <h6 className={classes.tableTitle}>{tableTitle}</h6>
      )}

      <Scrollbars
        className={clsx(
          { virtualAccount },
          className,
          classes.tableCustomScrollBar
        )}
        ref={scrollRef}
      >
        <div className={classes.tableWrapper}>
          <div>
            <Swipeable
              trackMouse
              preventDefaultTouchmoveEvent
              onSwiping={handleTableSwiping}
            >
              <Table stickyHeader>
                <EnhancedTableHead
                  sort={sort}
                  order={order}
                  tableKey={tableKey}
                  onRequestSort={handleRequestSort}
                  headCells={headCells}
                  customized={customized}
                />
                <EnhancedTableBody
                  headCells={headCells}
                  list={stableSort(list, getSorting(sort, order))}
                  error={error}
                  loading={loading}
                  customized={customized}
                />
              </Table>
            </Swipeable>
          </div>
        </div>
      </Scrollbars>
    </>
  );
}
